export enum PricingApi {
  // DEV-540: pricing behavior (mode, default margin, per-module cache /
  // always-editable switches) lives in its own `pricing-configuration`
  // document, not inside the quote configuration.
  Configuration = '/pricing/configuration',
  Get = '/pricing/get'
}
